import React, { useState, useEffect } from "react";
import FlatList from "flatlist-react";
import { ToastContainer } from "react-toastify";
import apilink from "../globals/Baseurls";
import axios from "axios";
import "react-activity/dist/library.css";

const Late = () => {
  const [deadSearchTerm, setDeadSearchTerm] = useState("");
  const [familycode, setFamilycode] = useState("");
  const [deadlist, setDeadlist] = useState([]);

  useEffect(() => {
    const getAsyncData = async () => {
      const familyData = await JSON.parse(
        localStorage.getItem("userFamilyData")
      );

      setFamilycode(familyData.record.familycode);

      const baseUrl = apilink.link;
      await axios
        .get(`${baseUrl}/family/members/${familyData.record.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            console.log(
              response.data.records.filter((item) => item.healed === "No")
            );
            setDeadlist(
              response.data.records.filter((item) => item.diedon !== null)
            );
          }
        })
        .catch((error) => {
          console.log(error.response.data.message);
        });
    };
    getAsyncData();
  }, []);

  const renderDeadPerson = (person, idx) => {
    return (
      <div style={{ flexDirection: "column", marginBottom: "30px" }} key={idx}>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #779d3838",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <div>
            <b>
              {person.alias} {person.surname}
            </b>
            <h6 style={{ fontFamily: "Open Sans" }}>
              {person.parent != null && (
                <>{person.gender == "Female" ? "Daughter Of" : "Son Of"} </>
              )}
              {person.parent == null ? "Root Member" : person.parentname}
            </h6>
            {person.parent != null && (
              <>
                <h6 style={{ fontFamily: "Open Sans" }}>
                  Child Number: {person.born}
                </h6>
              </>
            )}

            <b>Died On: {person.diedon}</b>
            <h6 style={{ fontFamily: "Open Sans" }}>
              Burried At:{" "}
              {person.burriedat == null ? "Not mentioned" : person.burriedat}
            </h6>
           
          </div>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
            }}
          >
            <span style={{ fontFamily: "Open Sans" }}>{person.residance}</span>
            <br></br>
            <span className="float-end" style={{ fontFamily: "Open Sans" }}>
              {person.phone}
            </span>
            <br />
            <img
              alt="logo"
              style={{
                width: "130px",
                height: "130px",
                resizeMode: "stretch",
                border: "1px solid green",
                marginTop: "5px",
                borderRadius: "5px",
                alignSelf: "flex-end",
              }}
              src={
                person.img == null
                  ? `https://treebackend.globalsparks.live/tree-backend/public/images/members/temp1.png`
                  : `https://treebackend.globalsparks.live/tree-backend/public/images/members/${person.img}`
              }
            />
          </div>
        </div>
      </div>
    );
  };

  const onDeadSearchInput = (e) => {
    setDeadSearchTerm(e.target.value);
  };

  return (
    <>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>Late Members</p>

        <span style={{ fontFamily: "Open Sans" }}>{familycode}</span>
      </div>

      <div
        style={{
          width: "100%",
          marginBottom: 30,
          height: 60,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <input
          placeholder={"Search late members. . ."}
          style={{
            width: "100%",
            borderWidth: 1,
            borderColor: "#779d38",
            borderRadius: 5,
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            paddingInline: 10,
            marginBottom: "10px",
          }}
          value={deadSearchTerm}
          onChange={onDeadSearchInput}
        />
      </div>
    
      <FlatList
        list={deadlist}
        renderItem={renderDeadPerson}
        renderWhenEmpty={() => (
          <div>
            <p style={{ color: "gray", fontFamily: "Open Sans" }}>
              No items matching your search . . .
            </p>
          </div>
        )}
        sortBy={["level", { key: "level", descending: true }]}
        //   searchBy={["alias", "surname"]}
        //   searchTerm={searchTerm}
        search={{
          by: ["alias", "surname"],
          term: deadSearchTerm,
          caseInsensitive: true,
        }}
        style={{ marginBottom: "700px" }}
      />

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Late;
